import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import PostImage from "Post/PostImage";

import {
  useGetProjectByIdQuery,
} from "services/project/projectApi";

import NullImage from "assets/images/Ryuusei-Null-Image.png";

import { useTheme } from "@mui/material";
import { TaggedImage } from "constructs/TaggedImage";

export interface ProjectTileProps {
  uid: string;
}

const ProjectTile = (props: ProjectTileProps) => {
  const theme = useTheme();
  // If window.location.hostname does not contains sukebei as part of it, then Ero should be excluded otherwise don't worry about it
  const userExclusions = !window.location.hostname.includes("sukebei") ? [ 
    { id: 2,  name: '', magnitude: 0}, 
    { id: 16,  name: '', magnitude: 0},
    { id: 24,  name: '', magnitude: 0},
  ] : [];
  // const project = useLazyGetProjectByIdQuery();
  const {
    data: project,
    isLoading,
    error,
  } = useGetProjectByIdQuery({ id: props.uid });

  
  if (isLoading) {
    return null;
  }
  
  if (!project) {
    return null;
  }

  // Get the Tagged Image or use the default NullImage
  let image: TaggedImage = (project.images.length && project.images[0])
    ??
  {
    uri: NullImage,
    tags: []
  };

  // image = {
  //   ...image,
  //   tags: [ { id: '1', name: 'General', magnitude: 5 }]
  // }

  
  return (
    <ImageListItem
      key={project.uid}
      rows={1}
      cols={1}
      sx={{ 
        width: 280,
        border: `4px solid ${theme.palette.secondary.dark}`,
        borderRadius: "10px",
        overflow: 'hidden',
      }}
      >
      {/* <picture>
        <img
          width={"100%"}
          src={project.image?.uri ?? NullImage}
          loading="lazy"
          alt={project.title}
        />
      </picture> */}
      <PostImage 
        tagExclusions={ userExclusions } // This is normally determined by the user's settings
        obfuscationMethod={'blur'}
        image={ image }
        link={ `/projects/${project.uid}`}
        data={ project }
      />

      <ImageListItemBar
        title={ project.title }
        position="top"
      ></ImageListItemBar>
    </ImageListItem>
  );
};

export default ProjectTile;
